<template>
    <div class="template-login-register">
        <header class="header-animation">
            <div class="top">
                <div class="container">
                    <a href="https://simoniot.com">
                        <img src="../../assets/img/logo-dark.png" alt="">
                    </a>

                    <RegisterLink :variant="'white'"></RegisterLink>
                </div>
            </div>

            <div class="lamp">
            </div>
            <div class="text"><span>Shattering Expectations in Iot</span></div>

            <div class="particles">
                <vue-particles  color="#17F9F9" linesColor="#16F8F8" :particlesNumber="100"></vue-particles>
            </div>
        </header>

        <div class="contentpage">
            <div class="container-login">
                <h3>Login</h3>
                <h4 v-if="passResetDone == false">Sign in to your account</h4>
                <h4 v-else>Your password has been changed, please login with your new credentials</h4>

                <div class="error-message" v-if="visibleError">
                    {{visibleError}}
                </div>

                <form class="fts-validation">
                    <fieldset :class="[(loginError) ? 'error-validation' : '', loginStepOne ? '' : 'locked', (patternLoginError) ? 'error-validation' : '']">
                        <label>
                            <i class="icon-user"></i>
                        </label>
                        <input type="text" name="ulogin" placeholder="Enter Login" @keyup="checkEmailPattern()" v-model="credential.userName" :disabled="loginStepOne == false">
                        <p class="fts-text-alert">Please fill this field with correct email address.</p>
                    </fieldset>

                    <fieldset :class="[(passError) ? 'error-validation' : '', loginStepOne ? 'hidden' : '']">
                        <label>
                            <i class="icon-lock"></i>
                        </label>
                        <input type="password" name="upassword" placeholder="Enter Password" v-model="credential.password">
                        <p class="fts-text-alert">This field is required</p>
                    </fieldset>

                    <button id="LoginContinueBtn" v-if="loginStepOne" type="submit" v-on:click.prevent="checkLogin()" :class="['btn', 'btn-sumbit', (patternLoginError) ? 'block-button' : '']">Continue</button>
                    <div v-else class="login-btns-box">
                        <button id="LoginSubmitBtn" type="submit" v-on:click.prevent="login()" class="btn btn-sumbit">Login</button>
                        <button id="LoginBackBtn" @click="backToLoginTyping()" class="btn btn-sumbit">Back</button>
                    </div>
                </form>

                <router-link v-if="loginStepOne == false" to="/forgot-password">Forgot password?</router-link>
            </div>
        </div>

        <footer>
            <RegisterLink :content="'Don\'t have an account? Register'"></RegisterLink>
        </footer>
        <b-modal size="md" ref="disabledAccount" id="disabledAccount" hide-header hide-footer centered>
            <i @click="hideDisabledModal()" class="fa fa-close disabled-close"></i>
            <img class="warning-icon" src="../../assets/img/unsaved-data.png" alt="warning-icon">
            <h3>Your Account Has Been Disabled</h3>
            <p>Your account has been disabled, and you currently no longer have access. To regain the account please contact us via <a href="mailto:support@simoniot.com">support@simoniot.com</a> or call <a href="tel:+18337466646">+1-833-746-6646</a>.</p>
            <button @click="hideDisabledModal()" class="btn btn-primary disabled-ok-btn">OK</button>
        </b-modal>

        <b-modal size="md" ref="linkExpired" id="linkExpired" hide-header hide-footer centered>
            <i @click="hideExpiredModal()" class="fa fa-close disabled-close"></i>
            <img class="warning-icon" src="../../assets/img/unsaved-data.png" alt="warning-icon">
            <h3>Link expired</h3>
            <p>Your registration link has expired. Please register again or contact us via <a href="mailto:support@simoniot.com">support@simoniot.com</a> or call <a href="tel:+18337466646">+1-833-746-6646</a>.</p>
            <button @click="hideExpiredModal()" class="btn btn-primary disabled-ok-btn">OK</button>
        </b-modal>

        <b-modal size="md" ref="linkExpiredGeneric" id="linkExpiredGeneric" hide-header hide-footer centered>
            <i @click="hideExpiredGenericModal()" class="fa fa-close disabled-close"></i>
            <img class="warning-icon" src="../../assets/img/unsaved-data.png" alt="warning-icon">
            <h3>Link Used</h3>
            <p>This link has been used, changes have been applied.</p>
            <button @click="hideExpiredGenericModal()" class="btn btn-primary disabled-ok-btn">OK</button>
        </b-modal>

        <b-modal data-keyboard="false" id="session-expired" size="md" class="session-expired" centered title="Session expired" ref="session-expired" hide-footer no-close-on-esc no-close-on-backdrop hide-header-close>
            <p>You have been logged out because of inactivity.</p>
            <button class="btn btn-success btn-block active" @click="closeExpireModal()">OK</button>
        </b-modal>
        <MultiCompanyLogin v-if="multiCompanyAccess" :isLogin="true" @closeModal="MCAClose()"></MultiCompanyLogin>
    </div>
</template>

<script>
import Vue from "vue";
import Axios from "axios";
import VueSession from "vue-session";
import globalStore from "../../variables";
import { error } from "util";
import VueParticles from 'vue-particles'
import VueCookies from 'vue-cookies'
import VueJwtDecode from 'vue-jwt-decode'
import MultiCompanyLogin from "../MultiCompanyLogin";
import keycloak from "../../main";

Vue.use(VueParticles)
Vue.use(VueSession);
Vue.use(VueCookies);
import RegisterLink from "@/views/RegisterLink";
Vue.$cookies.config('7d','','',true)

export default {
    name: "Login",
    components: {
        MultiCompanyLogin,
        RegisterLink
    },
    data() {
        return {
            visibleError: 0,
            credential: {
                userName: "",
                password: ""
            },
            loginError: false,
            passError: false,
            patternLoginError: false,
            passResetDone: false,
            multiCompanyAccess: false,
            loginStepOne: true
        };
    },
    mounted: function() {
        var timestamp = new Date().getTime();

        if (this.$session.get("token")) {
            this.$router.push("/admin");
        } else if (this.$cookies.get("token")) {
            this.$router.push("/dashboard");
        }

        if (this.$cookies.get('logoutInProgress') == 'true') {
            this.$cookies.remove('logoutInProgress')
        }

        if (this.$cookies.get('simsMarked') == 'true') {
            this.$cookies.remove('simsMarked');
        }

        if (sessionStorage.getItem('sessionExpired')) {
            this.$refs['session-expired'].show();
            sessionStorage.removeItem('sessionExpired');
        }

        if (sessionStorage.getItem('resetPasswordDone', true)) {
            this.passResetDone = true
            sessionStorage.removeItem('resetPasswordDone')
        }

        if (window.location.href.indexOf('linkexpired') > -1) {
            this.$refs['linkExpired'].show();
        }

        if (window.location.href.indexOf('linkused') > -1) {
            this.$refs['linkExpiredGeneric'].show();
        }

        if (this.$cookies.get('companyId') && !this.$cookies.get("token")) {
            this.$cookies.remove('companyId')
        }
    },
    methods: {
        checkEmailPattern() {
            //credential.userName
            if (this.credential.userName.match(/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i)) {
                this.patternLoginError = false;
            } else {
                this.patternLoginError = true;
            }
        },
        login: function () {

            var vxjs = this;

            if (this.credential.userName.length == 0 || this.credential.password.length == 0) {
                if (this.credential.userName.length == 0) {
                    this.loginError = true
                } else {
                    this.loginError = false
                }
                if (this.credential.password.length == 0) {
                    this.passError = true
                } else {
                    this.passError = false
                }
                return false;
            } else {
                this.loginError = false
                this.passError = false
            }

            Axios.post(globalStore.data.restApiUrl + "/login", this.credential)
                .then(response => {
                    this.$cookies.set('defaultLogin', true)
                    let SARoles = ['Owner','Super Admin','Fulfilment','Reseller','Support','Sales']
                    if (response.status == 200) {
                        let currentTime = Date.now();
                        let token = response.data.accessToken
                        let refreshToken = response.data.refreshToken
                        let associatedCustomerCompaniesIds = response.data.associatedCustomerCompaniesIds
                        let isSA = false
                        if (SARoles.indexOf(response.data.role) > -1) {
                            isSA = true
                            this.$session.set('isSA', true)
                            this.$session.start()
                            this.$session.set("token", token);
                            this.$session.set('refreshToken', refreshToken);
                            this.$session.set('tokenSetTime', currentTime);
                        } else {
                            this.$cookies.set('isSA', false)
                            this.$cookies.set('refreshFlag', false)
                            this.$cookies.set("token", token, "30MIN");
                            this.$cookies.set('refreshToken', refreshToken, "30MIN");
                            this.$cookies.set('tokenSetTime', currentTime);
                            this.$cookies.set('lastActiviti', currentTime);
                        }
                        if (isSA || (isSA == false && (associatedCustomerCompaniesIds.length < 2))) {
                            Axios.get(globalStore.data.restApiUrl + '/user-settings/user-session')
                                .then(response => {
                                    if (isSA) {
                                        this.$session.set('userEmail', this.credential.userName)
                                        this.$session.set('userLevel', response.data.mainRoleName)
                                        this.$session.set('saPermissions', response.data.saPermissions);
                                        this.$session.set('saCompanies', response.data.saCompanies);
                                        this.$session.set('userLevelId', response.data.mainRoleId)
                                        this.$session.set('userId', response.data.userId)
                                        this.$session.set('firstName', response.data.firstName)
                                        this.$session.set('lastName', response.data.lastName)

                                        if (this.$cookies.get(this.credential.userName + '-last-active-page')) {
                                            if (this.$cookies.get(this.credential.userName + '-company-data')) {
                                                let companyData = this.$cookies.get(this.credential.userName + '-company-data')
                                                this.$session.set('companyId', companyData.companyId)
                                                this.$session.set('companyName', companyData.companyName)
                                                this.$session.set('typeAccount', companyData.typeAccount)
                                                this.$session.set('coldStockAccess', companyData.coldStockAccess)
                                                this.$session.set('tier2Roaming', companyData.tier2Roaming)
                                                this.$session.set('voiceAccess', companyData.voiceAccess)
                                                this.$session.set('hotSpotAccess', companyData.hotSpotAccess)
                                                this.$session.set('nbIoTPlans', companyData.nbIoTPlans)
                                                this.$session.set('catM1Plans', companyData.catM1Plans)
                                                this.$session.set('simonActiveReady', companyData.simonActiveReady)
                                                this.$session.set('simonCarrierAvailable', companyData.simonCarrierAvailable)
                                                this.$session.set('tmobileCarrierAvailable', companyData.tmobileCarrierAvailable)
                                                this.$session.set('vodafoneCarrierAvailable', companyData.vodafoneCarrierAvailable)
                                                if (this.$cookies.get(this.credential.userName + '-last-active-page').indexOf('/balance-and-pools/pool-details') == -1) {
                                                    vxjs.$router.push(this.$cookies.get(this.credential.userName + '-last-active-page'));
                                                } else {
                                                    vxjs.$router.push('/balance-and-pools')
                                                }
                                            } else {
                                                vxjs.$router.push(this.$cookies.get(this.credential.userName + '-last-active-page'));
                                            }
                                            this.$cookies.remove(this.credential.userName + '-last-active-page')
                                        } else {
                                            vxjs.$router.push("/admin");
                                        }
                                    } else {
                                        this.$cookies.set('companyId', response.data.mainCompanyId);
                                        this.$cookies.set('userEmail', response.data.username);
                                        this.$cookies.set('userLevel', response.data.mainRoleName)
                                        this.$cookies.set('userLevelId', response.data.mainRoleId)
                                        this.$cookies.set('userId', response.data.userId)
                                        const companyId = response.data.mainCompanyId
                                        Axios.get(globalStore.data.restApiUrl + '/account/users/current?companyId=' + companyId)
                                            .then(response => {
                                                this.$cookies.set('firstName', response.data.firstName)
                                                this.$cookies.set('lastName', response.data.lastName)
                                                this.$cookies.set('tokenSetTime', currentTime);
                                                this.$cookies.set('permissions', response.data.permissions.join(','));
                                                if (response.data.hasPendingInvitation) {
                                                    this.$cookies.set('hasPendingInvitation', true);
                                                }
                                                if (response.data.acceptedAgreementId != undefined) {
                                                    this.$cookies.set('acceptedAgreementId', response.data.acceptedAgreementId)
                                                } else {
                                                    this.$cookies.set('acceptedAgreementId', false)
                                                }


                                                Axios.get(`${globalStore.data.restApiUrl}/account?companyId=${companyId}`)
                                                    .then(response => {
                                                        this.$cookies.set('typeAccount', response.data.wallet.mode);
                                                        this.$cookies.set('coldStockAccess', response.data.companyPermissions.indexOf('COLD_STOCK_ACCESS') > -1);
                                                        this.$cookies.set('tier2Roaming', response.data.companyPermissions.indexOf('TIER_2_INTERNATIONAL_ROAMING') > -1);
                                                        this.$cookies.set('voiceAccess', response.data.companyPermissions.indexOf('VOICE_ACCESS') > -1);
                                                        this.$cookies.set('hotSpotAccess', response.data.companyPermissions.indexOf('HOT_SPOT_PLANS_ACCESS') > -1);
                                                        this.$cookies.set('nbIoTPlans', response.data.companyPermissions.indexOf('NB_IOT_PLANS_ACCESS') > -1);
                                                        this.$cookies.set('catM1Plans', response.data.companyPermissions.indexOf('CAT_M1_PLANS_ACCESS') > -1);
                                                        this.$cookies.set('simonActiveReady', response.data.companyPermissions.indexOf('NETCRACKER_ACTIVE_READY') > -1);
                                                        this.$cookies.set('companyId', response.data.companyId);
                                                        this.$cookies.set('companyName', response.data.companyName);

                                                        if (response.data.displayedCarriers.indexOf(1) > -1) {
                                                            this.$cookies.set('simonCarrierAvailable', true);
                                                        } else {
                                                            this.$cookies.set('simonCarrierAvailable', false);
                                                        }
                                                        if (response.data.displayedCarriers.indexOf(2) > -1) {
                                                            this.$cookies.set('tmobileCarrierAvailable', true);
                                                        } else {
                                                            this.$cookies.set('tmobileCarrierAvailable', false);
                                                        }
                                                        if (response.data.displayedCarriers.indexOf(3) > -1) {
                                                            this.$cookies.set('vodafoneCarrierAvailable', true);
                                                        } else {
                                                            this.$cookies.set('vodafoneCarrierAvailable', false);
                                                        }
                                                        if (response.data.displayedCarriers.indexOf(4) > -1) {
                                                            this.$cookies.set('koreCarrierAvailable', true);
                                                        } else {
                                                            this.$cookies.set('koreCarrierAvailable', false);
                                                        }

                                                        if (response.data.requireAdditionalInfo && this.$cookies.get('userLevelId') == 9) {
                                                            vxjs.$router.push("/additional-info");
                                                        } else {
                                                            this.$emit('updateSidebar');
                                                            vxjs.$router.push("/dashboard");
                                                        }
                                                    }).catch(error => {
                                                    this.$notify({
                                                        type: 'warn',
                                                        group: 'notification',
                                                        title: 'Getting data error',
                                                        text: 'Something was wrong with getting company details. Please contact with',
                                                        duration: 5000,
                                                    });
                                                    console.log(error)
                                                    return false
                                                })

                                            }).catch(error => {
                                            if (error.response.data == 'Users ' + this.credential.userName + ' account is disabled.') {
                                                vxjs.visibleError = 'This account is disabled. Please, contact your administrator.';
                                            } else {
                                                vxjs.visibleError = 'Unexpected error. Please contact support.';
                                            }
                                            console.log(error)
                                            // return false
                                        })
                                    }
                                })
                        } else {
                            this.$cookies.set('userEmail', this.credential.userName)
                            this.$cookies.set('multiCompanyAccess', true)
                            this.$cookies.set('multiCompanyAccessId', associatedCustomerCompaniesIds[0])
                            this.multiCompanyAccess = true
                        }
                    } else {
                        console.log(response)
                        vxjs.visibleError = 'Unexpected error. Please contact support.';
                    }
                }).catch(error => {
                    console.log(error)
                    if (error.response && error.response.data && error.response.data.errors) {
                        let errorStatus = error.response.status
                        let errorCode = error.response.data.errors[0].errorCode
                        let errorMessage = error.response.data.errors[0].errorMessage

                        if (errorStatus == 401 && errorCode == 'LoginException' && errorMessage == 'Company you belong to is disabled.') {
                            this.$refs['disabledAccount'].show();
                        } else if (errorStatus == 401 && errorCode == 'LoginException' && errorMessage == ('Users ' + this.credential.userName + ' account is disabled.')) {
                            this.$refs['disabledAccount'].show();
                        } else if (errorStatus == 401 && errorCode == 'LoginException' && errorMessage == 'Password reset required.') {
                            this.goToSetPswd(this.credential.userName)
                        } else if (errorStatus == 401 && errorCode == 'LoginException' && errorMessage == 'Account not activated yet. Need to be confirmed before first login.') {
                            vxjs.visibleError = 'Account not activated yet. Please check your e-mail to confirm registration.'
                        } else if (errorStatus == 401 && errorCode == 'TooManyIncorrectLoginAttemptsException') {
                            this.$notify({
                                type: 'error',
                                group: 'notification',
                                title: 'Too Many Incorrect Login Attempts Exception',
                                text: errorMessage,
                                duration: 5000,
                            })
                        } else if (errorStatus == 401 && errorCode == 'LoginException' && errorMessage == 'Invalid username or password') {
                            console.log(error)
                            vxjs.visibleError = 'Unable to login, please check your credentials.';
                        } else {
                            console.log(error)
                            vxjs.visibleError = 'Unexpected error. Please contact support.';
                        }
                    } else {
                        vxjs.visibleError = 'Unexpected error. Please contact support.';
                    }
                });
        },
        hideDisabledModal() {
            this.$refs['disabledAccount'].hide();
        },
        closeExpireModal() {
            this.$refs['session-expired'].hide();
        },
        hideExpiredModal() {
            this.$refs['linkExpired'].hide();
        },
        hideExpiredGenericModal() {
            this.$refs['linkExpiredGeneric'].hide();
        },
        goToSetPswd(username) {
            localStorage.setItem('setPswdLogin', username)
            this.$router.push('/set-password')
        },
        MCAClose() {
            this.multiCompanyAccess = false
        },
        backToLoginTyping() {
            this.loginStepOne = true
        },
        checkLogin() {
            if (this.credential.userName.length == 0) {
                this.loginError = true
            } else {
                this.loginError = false
                Axios.post(globalStore.data.restApiUrl + '/auth-type', {email: this.credential.userName})
                    .then(response => {
                        if (response.data == 'SIMON') {
                            this.loginStepOne = false
                        } else {
                            this.$router.push('/redirect')
                        }
                    })
                    .catch(error => {
                        this.loginError = true
                    })
            }
        }
    }
};
</script>

<style lang="scss">

header.header-animation {
    position: relative;

    .top {
        position: absolute;
        padding: 20px 0;
        top: 0;
        left: 0;
        right: 0;

        .container {
            display: flex;
            justify-content: space-between;
			align-items: center;

            a {
                color: #fff;
                font: 400 15px/16px "Roboto", "Arial", sans-serif;
            }
        }
    }

    .lamp {
        position: absolute;
        height: 344px;
        width: 512px;
        margin-left: auto;
        margin-right: auto;
        left: 0;
        right: 0;
        top: 84px;
        background: transparent url("../../assets/img/lamp-login.png") no-repeat center center;
    }

    .text {
        position: absolute;
        width: 100%;
        left: 0;
        right: 0;
        top: 213px;
        background: rgba(1, 24, 38, .84);
        text-align: center;
        font: 700 37px/43px "Roboto", "Arial", sans-serif;
        text-transform: uppercase;
        letter-spacing: 4px;
        color: #fff;
    }
}

.particles {
    background-color: #021927;
    height: 480px;
    overflow: hidden;
    #particles-js {
        height: 480px;
    }
}
.gradient-login {
    background: #00ff97; /* Old browsers */
    background: -moz-linear-gradient(45deg,  #00ff97 0%, #0055ff 99%); /* FF3.6-15 */
    background: -webkit-linear-gradient(45deg,  #00ff97 0%,#0055ff 99%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(45deg,  #00ff97 0%,#0055ff 99%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ff97', endColorstr='#0055ff',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
    background-color: #e4e5e6;
}

.contentpage {
    background-color: #F8F8F8;
    padding: 43px 0 90px;
    text-align: center;

    h3 {
        display: block;
        margin-bottom: 13px;
        font: 700 20px/26px "Roboto", "Arial", sans-serif;
        color: #000;
    }

    h4 {
        display: block;
        margin-bottom: 20px;
        font: 400 14px/19px "Roboto", "Arial", sans-serif;
        color: #9F9F9F;
    }

    form {
        fieldset {
            margin-bottom: 16px;
            &.locked {
                opacity: 0.7;
            }
            &.hidden {
                display: none;
            }
            label {
                display: inline-block;
                vertical-align: top;
                width: 40px;
                height: 35px;
                margin: 0;
                background-color: #fff;
                border-radius: 5px 0 0 5px ;
                border-width: 1px 0 1px 1px;
                border-style: solid;
                border-color: #E4E7EA;
                line-height: 35px;
            }
            input {
                display: inline-block;
                vertical-align: top;
                width: 262px;
                height: 35px;
                padding: 0 10px;
                background-color: #E4E5E6;
                border-radius: 0 5px 5px 0;
                border-width: 1px 1px 1px 1px;
                border-style: solid;
                border-color: #C9CFD4;
                line-height: 35px;
                outline: none !important;
                box-sizing: border-box;
            }
        }

        .btn-sumbit {
            height: 35px;
            padding: 0 25px;
            margin-bottom: 20px;
            background-color: #0088FF;
            border-radius: 5px;
            font: 400 14px/33px "Roboto", "Arial", sans-serif;
            color: #fff;

            &.block-button {
                cursor: not-allowed;
                pointer-events: none;
                opacity: .6;
            }
        }
    }

    a {
        font-size: 14px;
    }
    .login-btns-box {
        display: flex;
        flex-direction: row-reverse;
        justify-content: center;
        gap: 0 12px;
    }
}

.error-message {
    padding-bottom: 10px;
    color: red;
}

footer {
    padding: 25px 0 100px;
    text-align: center;
}

#disabledAccount___BV_modal_content_,
#linkExpired___BV_modal_content_,
#linkExpiredGeneric___BV_modal_content_ {
    .modal-body {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .disabled-close {
            position: absolute;
            top: 10px;
            right: 10px;
        }
        .warning-icon {
            margin-bottom: 12px;
        }
        h3 {
            margin-bottom: 20px;
            font-size: 15px
        }
        p {
            text-align: center;
            margin-bottom: 20px;
        }
        .disabled-ok-btn {
            width: 80px;
        }
    }
}

#session-expired {
    z-index: 3200;
    background-color: rgba(0, 0, 0, .9);
    header {
        height: 58px;
    }
    .close {
        display: none;
    }
}

</style>
